import {useState, useEffect} from "react"
import { getSelectUser } from "./nav-profile.resource"
import { get } from "lodash"

export function useSwitchUser() {
  // Used to switch from one multitenant user to another.  This code
  // is a modified version of the export from login-ui by the same name
  const [user, setUser] = useState();

  useEffect(() => {
    if (user) {
      const subscription = getSelectUser(user.id).subscribe(
        (results) => {
          postUserSwitchRedirect(results.instance_url);
        },
        (e) => {
          if (e.status === 418) {
            const redirectUrl = get(e, "data.body.redirect_url");
            if (redirectUrl) {
              window.location.href = redirectUrl;
            } else {
              throw new Error(
                `POST /token responded with 418 to indicate user is on wrong domain, but directory service did not specify what the correct domain is`
              );
            }
          }
        }
      );
      return () => {
        subscription.unsubscribe();
      };
    }
  }, [user]);

  return setUser;
}

const postUserSwitchRedirect = (url) => {
  const validRedirectUrl = url?.match(/^https?:\/\/[\w-]*\.([\w]*\.)?(canopy)(\.dev|tax\.com|\.ninja|\.com)/);
  const validLocalUrl = url?.match(/^http:\/\/127\.0\.0\.1:\d\d\d\d\d?/);
  const redirectUrl = (validRedirectUrl || validLocalUrl) ? url : window.location.origin
  window.location.href = redirectUrl
}
